<template>
    <Breadcrumbs main="Timeline" title="Timeline" />
    <div class="container-fluid">
        <div class="row">
            <basicTimeline />
            <hoveringTimeline />
            <variationTimeline />
            <horizontalTimeline />
            <timelineView />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/basicTimeline.vue"))
const hoveringTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/hoveringTimeline.vue"))
const variationTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/variationTimeline.vue"))
const horizontalTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/horizontalTimeline.vue"))
const timelineView = defineAsyncComponent(() => import("@/components/theme/advance/timeline/timelineView.vue"))
</script>